import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import PricingCard from "./PricingCard";
import Box from "@mui/material/Box";
import Switch from "../Form/Switch";
import { MONTHLY, YEARLY } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import Typography from "@mui/material/Typography";
import { useSelectorApp } from "../../lib/redux";
import {
  RECURRENT_TYPES,
  PLAN_TYPE_CREDITS,
  PLAN_ENTERPRISE,
} from "../../utils/constants";
import CreditUsageInfo from "./CreditUsageInfo";

/** Middle paid tier in the row (enterprise is never featured). */
const getFeaturedPlanId = (plans) => {
  const paidPlans = plans.filter((plan) => plan.id !== PLAN_ENTERPRISE);
  if (paidPlans.length === 0) return null;
  const centerIndex = Math.floor((paidPlans.length - 1) / 2);
  return paidPlans[centerIndex]?.id ?? null;
};

const PricingCardsContainer = ({
  isUpgrade,
  onUpgradeSubscription = () => {},
  recurrent,
  onChangeRecurrent = () => {},
  plans = [],
  typeOfPlan,
  onOpenBookDemo = () => {},
  checkoutPromo = null,
  isCheckoutPromoLoading = false,
}) => {
  const { t } = useTranslationApp();
  const subscriptionPlan = useSelectorApp(
    (state) => state.payments.subscriptionPlan
  );
  const featuredPlanID = getFeaturedPlanId(plans);

  const commonSxTextTab = {
    fontSize: {
      xs: "0.7rem",
      sm: "1rem",
    },
  };

  return (
    <Container
      maxWidth="xlg"
      sx={{
        px: {
          md: 4,
          xs: 3,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          mb: {
            xs: 2,
            sm: 3,
          },
        }}
      >
        {!subscriptionPlan && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Typography variant="body1" sx={commonSxTextTab}>
              {t(MONTHLY)}
            </Typography>
            <Switch
              id="pricing-recurrent-switch"
              isActive={recurrent === RECURRENT_TYPES.yearly}
              onChangeIsActive={(active) =>
                onChangeRecurrent(
                  active ? RECURRENT_TYPES.yearly : RECURRENT_TYPES.monthly
                )
              }
              hasLabel={false}
            />
            <Typography variant="body1" sx={commonSxTextTab}>
              {t(YEARLY)}
            </Typography>
          </Box>
        )}
      </Box>

      <Grid
        container
        spacing={2}
        alignItems="stretch"
        justifyContent="center"
        sx={{ mb: typeOfPlan === PLAN_TYPE_CREDITS ? 4 : 0 }}
      >
        {plans.map((plan) => (
          <Grid
            item
            key={plan.id}
            sx={{
              width: {
                xs: "100%",
                sm: "unset",
              },
              display: "flex",
              justifyContent: {
                xs: "center",
              },
            }}
          >
            <PricingCard
              isUpgrade={isUpgrade}
              data={plan}
              recurrent={recurrent}
              onUpgradeSubscription={onUpgradeSubscription}
              featuredPlanID={featuredPlanID}
              subscriptionTierRelation={plan.subscriptionTierRelation}
              onOpenBookDemo={onOpenBookDemo}
              checkoutPromo={checkoutPromo}
              isCheckoutPromoLoading={isCheckoutPromoLoading}
            />
          </Grid>
        ))}
      </Grid>

      {typeOfPlan === PLAN_TYPE_CREDITS && <CreditUsageInfo />}
    </Container>
  );
};

export default PricingCardsContainer;
